<template>
    <div>
        <ul
            class="education-filters"
            :class="{ 'education-filters--active': showFilters }"
        >
            <education-filter
                v-for="(filter, name) in filtersOptions"
                :key="filter.id"
                v-model="value[name]"
                :multi-select="name.toLowerCase() !== 'educationtypes'"
                :filter="filter"
            ></education-filter>
        </ul>
        <div
            id="affix"
            :class="affixClass"
            :style="{ top: topOffset + 'px' }"
            class="education-filters__toggle d-lg-none"
        >
            <button class="btn btn-secondary" @click="toggleFilters">
                {{ showFilters ? 'Sluit Filters' : 'Open Filters' }}
            </button>
        </div>
    </div>
</template>

<script>
import EducationFilter from '@/components/education/education-filter';

export default {
    components: {
        EducationFilter
    },
    props: {
        filtersOptions: {
            type: Object,
            default() {
                return {};
            }
        },
        value: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            affixClass: '',
            topOffset: 0,
            affixItem: null,
            affixItemStop: null,
            affixTopOffset: 0,
            showFilters: false,
            selectedFilters: {}
        };
    },

    watch: {
        selectedFilters: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        }
    },
    mounted() {
        this.affixItem = document.getElementById('affix');
        this.affixItemStop = document.getElementsByClassName('footer')[0];
        this.scrolling();
        this.resize();
        window.addEventListener('scroll', this.scrolling);
        window.addEventListener('resize', this.resize);
    },

    methods: {
        scrolling: function() {
            let extraTopOffset = 285;
            if (window.innerWidth < 768) {
                extraTopOffset = 207;
            }

            const topOffset =
                extraTopOffset + 10 + this.affixItemStop.clientHeight;
            const contentHeight = document.getElementsByTagName('html')[0]
                .offsetHeight;
            const windowHeight = window.innerHeight;
            const offsetTop = window.scrollY;
            const result = contentHeight - windowHeight - offsetTop;
            if (result < 84) {
                this.affixClass = 'affix-bottom';
                this.topOffset = contentHeight - topOffset;
            } else {
                this.affixClass = 'affix';
                this.topOffset = windowHeight - 84;
            }
        },
        resize: function() {
            this.scrolling();
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        }
    }
};
</script>

<style lang="scss" scoped>
.education-filters {
    margin: 0;
    position: fixed;
    bottom: 80px;
    left: 0;
    width: 100%;
    height: 0;
    z-index: 10;
    background-color: $color-white;
    transition: height 0.3s $easeInOutQuad;
    list-style: none;
    overflow: scroll;

    &--active {
        padding: 80px 60px 0;
        height: calc(100% - 80px);
    }

    @include media-breakpoint-up(md) {
        &--active {
            padding: 130px 60px 0;
        }
    }

    @include media-breakpoint-up(lg) {
        position: static;
        padding: 0;
        overflow: visible;
        height: auto;
    }
}

.education-filters__toggle {
    position: fixed;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 20px 0 15px 0;
    z-index: 10;
    background-color: $color-white;

    .btn:focus {
        outline: none;
    }
}
#affix {
    z-index: 99;
}
.affix {
    z-index: 99;
    position: fixed;
}
.affix-bottom {
    z-index: 99;
    position: absolute;
}
</style>
